import { FC, useEffect, useState } from "react";
import { signOut } from "./Utils";
import { Auth } from "aws-amplify";
import Status404 from "./content/pages/Status/Status404";
import { useNavigate } from "react-router-dom";

interface PropType {
  component: JSX.Element;
  name: string;
}

const ProtectedRoute: FC<PropType> = ({ component: Component, name: name }) => {
  const [user, setUserData] = useState({ name: "", role: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const sessionMgt = async () => {
      const session = await Auth.currentSession();
      const decodedToken = session.getIdToken().decodePayload();
      const epochNow = Math.floor(Date.now() / 1000);
      const diff = decodedToken.exp - epochNow;
      if (diff < 0) {
        signOut(navigate);
      }
    };
    sessionMgt();

    if (user.name === "") {
      Auth.currentAuthenticatedUser()
        .then((data) => {
          const userData = {
            name: data.attributes["name"],
            role: data.attributes["custom:role"],
          };
          setUserData(userData);
        })
        .catch((err) => console.log(err));
    }
  });

  // console.log(user.role, ' ', name, ' ');

  if (user.role === "Admin") {
    if (
      name === "TeaRetinaAnalysis" ||
      name === "BenchmarkAnalysis" ||
      name === "Models" ||
      name === "BenchmarkResults" ||
      name === "BenchmarkJobs" ||
      name === "UploadModels" ||
      name === "WeatherAnalytics" ||
      name === "PriceHistory" ||
      name === "ExchangeRate" ||
      name === "Demo" ||
      name === "WeatherDemo" ||
      name === "FileUpload" ||
      name === "FileUploadTask" ||
      name === "UserManagement" ||
      name === "UserCreation" ||
      name === "UserGroupCreation" ||
      name === "UserGroups" ||
      name === "FileImport" ||
      name === "FileExport" ||
      name === "TeaTalk" ||
      name === "TeaRetinaManage" ||
      name === "TeaRetinaMatch" ||
      name === "TeaRetinaImages" ||
      name === "TeaRetinaMatches" ||
      name === "TeaRetinaLotMode" ||
      name === "TeaRetinaLotModeiew" ||
      name === "TeaRetinaHistories" ||
      name === "TeaRetinaCatpured" ||
      name === "TeaRetinaHistory" ||
      name === "TeaRetinaCapture" ||
      name === "BatchUpload" ||
      name === "ModelDeployment" ||
      name === "AuditTable" ||
      name === "BatchSelection" ||
      name === "Labeling" ||
      name === "ClientManagement" ||
      name === "DensityLabeling" ||
      name === "Environments" ||
      name === "MixingDashboard" ||
      name === "LotProgressDashboard" ||
      name === "LabelingAssignedFiles" ||
      name === "LabelingAllFiles" ||
      name === "LabelingInterface" ||
      name === "CatalogTextFileUpload" ||
      name === "LabelingFileUpload" ||
      name === "SellingMarks" ||
      name === "DataTransfer"
    )
      return Component;
  }

  if (user.role === "Standard User")
    if (
      name === "TeaRetinaAnalysis" ||
      name === "TeaRetinaImages" ||
      name === "BenchmarkAnalysis" ||
      name === "Models" ||
      name === "BenchmarkResults" ||
      name === "BenchmarkJobs" ||
      name === "UploadModels" ||
      name === "WeatherAnalytics" ||
      name === "PriceHistory" ||
      name === "ExchangeRate" ||
      name === "Demo" ||
      name === "WeatherDemo" ||
      name === "FileExport" ||
      name === "MixingDashboard" ||
      name === "LotProgressDashboard" ||
      name === "LabelingAssignedFiles" ||
      name === "LabelingAllFiles" ||
      name === "LabelingInterface" ||
      name === "LabelingFileUpload" ||
      name === "SellingMarks"
    )
      return Component;

  if (user.role === "Operator")
    if (
      name === "FileUpload" ||
      name === "FileImport" ||
      name === "FileExport" ||
      name === "FileUploadTask" ||
      name === "MixingDashboard" ||
      name === "LotProgressDashboard" ||
      name === "LabelingAssignedFiles" ||
      name === "LabelingAllFiles" ||
      name === "LabelingInterface" ||
      name === "LabelingFileUpload"
    )
      return Component;

  return <Status404 />;
};

export default ProtectedRoute;
